import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Component 1 — Foundations, Grooves & Body Control', 'Included'], ['Component 2 — Footwork, Steps & Skill Progressions', 'Included'], ['Component 3 — Combinations, Freestyle & Choreography', 'Included'], ['Component 4 — Performance, Class Planning & Instructor System', 'Included'], ['Component 5 — The 5 Strategic Bonuses', '$58.00'], ['Component 6 — The Full Instructor Toolkit', 'Included']];
export function ValueStack() {
  return <section className="py-24 px-4 bg-cream" data-id="element-319" data-mp="2n0q6pnnpd2dp">
      <div className="max-w-3xl mx-auto" data-id="element-320" data-mp="2980g15x8b9a9">
        <div className="text-center mb-10" data-id="element-321" data-mp="2954ihipammmc">
          <h2 className="text-3xl md:text-4xl font-serif font-bold uppercase text-ink" data-id="element-322" data-mp="2d8ajaatmzllf">
            Total value of the complete 6-in-1 system
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream-light border border-gold rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-323" data-mp="30wk5hduribd3">
          <ul className="divide-y divide-line" data-id="element-324" data-mp="1ohbewgmh3kma">
            {rows.map(([label, value], i) => <li key={i} className="flex items-center justify-between gap-4 py-3 text-sm md:text-base" data-id="element-325" data-mp="2367vj22li5yi" data-mpi={i}>
                <span className="text-ink-soft" data-id="element-326" data-mp="1ycmsgvm5alsg">{label}</span>
                <span className={`shrink-0 font-semibold ${value === 'Included' ? 'text-ink-muted' : 'text-burgundy'}`} data-id="element-327" data-mp="2c4jm543gp3qy">
                  {value}
                </span>
              </li>)}
          </ul>

          <div className="mt-6 pt-6 border-t-2 border-ink/10 space-y-2" data-id="element-328" data-mp="2h68w0gey7bdg">
            <div className="flex items-center justify-between" data-id="element-329" data-mp="rphl16r52rz3">
              <span className="text-lg text-ink-soft" data-id="element-330" data-mp="rrub6771w8n8">Total value</span>
              <span className="text-2xl text-ink-muted line-through font-serif" data-id="element-331" data-mp="mshfqy245t91">
                $105.00
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-332" data-mp="2rs8wq6jia0xc">
              <span className="text-lg font-bold text-ink uppercase" data-id="element-333" data-mp="2rsiqm57o8s8b">
                Your price today
              </span>
              <span className="text-4xl md:text-5xl font-serif font-bold text-burgundy" data-id="element-334" data-mp="30sxf1dfxmng1">
                $27.00
              </span>
            </div>
          </div>

          <p className="text-center text-sm text-ink-muted mt-6" data-id="element-335" data-mp="35riehand133f">
            Only available at this price for a limited time.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-336" data-mp="3fhl6p8mnqd0p" />
      </div>
    </section>;
}